import { default as ReactSelect } from "react-select";

interface SelectProps {
  label: string;
  name: string;
  value: any;
  onChange: (e: any) => void;
  className?: string;
  fetchOptions: any;
  disabled?: boolean;
}

export function SelectText({
  label,
  name,
  value,
  onChange,
  fetchOptions,
  className: clasName,
  disabled,
}: SelectProps) {
  return (
    <div className={`flex flex-col text-grey ${clasName}`}>
      <label className="3xl:text-md text-sm font-thin mb-1.5">{label} :</label>
      <ReactSelect
        isClearable
        isSearchable
        isDisabled={disabled}
        name={name}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        menuPlacement="auto"
        styles={{
          control: (provided) => ({
            ...provided,
            backgroundColor: "white",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            borderColor: "lightblue",
            borderWidth: 2,
            borderRadius: "0.375rem",
            height: "44px",
            minHeight: "2.25rem",
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        options={fetchOptions}
        onChange={onChange}
        value={
          fetchOptions.find((option: any) => option.value === value) || null
        }
      />
    </div>
  );
}
